import {isSelectedTab} from './../../../utils/commonFunctions';
import UseApiService from './../../../services/Api.service';
import * as constants from './../../../constants/constants'
import { useEffect, useState } from 'react';

import { Table } from 'antd';

export default function CustomerVisitasComponent({data,selectedTab}){
  const [visitas,setVisitas] = useState([]);

  const columns = [
    {
      title: 'id',
      dataIndex: 'secuencia',
      sorter: (a, b) => a.secuencia - b.secuencia, 
    },
    {
      title: '',
      dataIndex: 'imagepath',
      render: (text,record) => 
        ( <>
            <img src={!record.imagepath.includes('https')?"https://"+record.site+record.imagepath:record.imagepath} style={{width:'80px'}} />
          </>
        )
    },
    {
      title: 'Seccion',
      dataIndex: 'section',
      //sorter: (a, b) => a.name.localeCompare(b.section), 
    },
    {
      title: 'Titulo',
      dataIndex: 'title',
      render: (text,record) => (
        <>
          <a href={record.url} alt={text} title={text} target='_blank'>{text}</a>
        </>
      )
      //sorter: (a, b) => a.name.localeCompare(b.title), 
    },    
    {
      title: 'Fecha',
      dataIndex: 'date',
      render: (text,record) => (
        <>
        <span>{record.date?.substring(0,10)}</span>
        <br/>
        <span>{record.date?.substring(11,20)}</span>
        </>
      ),
      sorter: (a, b) => a.date.localeCompare(b.date), 
    },
    
  ];

  useEffect(()=>{
    /*getData();*/
    setVisitas(data);
  },[])

  const getData = () =>{
    let url = constants.U_API+"?type=visitas";
    UseApiService(url,{method:'GET'})
    .then(({data,error})=>{
      if(error){
        console.log(error);
      }
      else{        
        console.log(data);
        setVisitas(data.articulos.slice(0,20));
      }
    })
    .catch((e)=>{
      console.log(e);
    })
    .finally((e)=>{
      console.log(e);
    })
  }

  return(
    <>
      <div className={isSelectedTab(selectedTab,'visitas')}>
        <Table
          columns={columns} 
          dataSource={data} 
          pagination={{ pageSize: 6 }} 
          rowKey="id"
          size="small"
        />
        
        {/*
        <table className='table dataTable no-footer'>
          <thead className='thead-light'>
            <tr>
              <th>Imagen</th>
              <th>Detalles</th>
              <th>Titulo</th>
            </tr>            
          </thead>
          <tbody>
            
            
            {visitas.map((item,index)=>(
              <tr key={index}>                
                <td>
                  <img className='img' style={{height:'80px'}} src={item.imagepath} />
                </td>
                <td>
                  <div className='text-muted'>{item.publicationdate}</div>
                  <div>{item.section}</div>
                  <div>{item.author}</div>                  
                </td>              
                <td>
                  <div>{item.title}</div>
                  <div>
                    <a href={'https://www.eluniversal.com.mx/'+item.url} target='_blank'>{item.url}</a>
                  </div>
                  
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        */}
      </div>      
    </>
  )
}